module.exports = __webpack_public_path__ + "91f7c8344f45715a79c7ee6d7a36c4ca.png";